import {
  WebsiteButtonTypes,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { useThemeColor } from '.'
import { buttonColorKeyMap } from 'src/editor/store/website-settings/website-settings-selector'

export const useSelectedButtonColor = (
  buttonType: WebsiteButtonTypes = WebsiteSettingsTypographyTypeEnum.PrimaryButton,
) => {
  const { buttons } = useThemeColor()
  const keys = buttonColorKeyMap[buttonType]
  return {
    buttonTextColor: buttons?.[keys.buttonTextColor] || '',
    buttonBackgroundColor: buttons?.[keys.buttonBackgroundColor] || '',
    hoveredButtonBackgroundColor:
      buttons?.[keys.hoveredButtonBackgroundColor] || '',
    pressedButtonBackgroundColor:
      buttons?.[keys.pressedButtonBackgroundColor] || '',
  }
}
